const workExperienceOptions = [{
		value: 1,
		label: '1年'
	}, {
		value: 2,
		label: '2年'
	}, {
		value: 3,
		label: '3年'
	}, {
		value: 4,
		label: '4年'
	},
	{
		value: 5,
		label: '5年'
	}, {
		value: 6,
		label: '6年'
	}, {
		value: 7,
		label: '7年'
	}, {
		value: 8,
		label: '8年'
	}, {
		value: 9,
		label: '9年'
	}, {
		value: 10,
		label: '10年'
	}, {
		value: 11,
		label: '11年'
	}, {
		value: 12,
		label: '12年'
	}, {
		value: 13,
		label: '13年'
	}, {
		value: 14,
		label: '14年'
	}, {
		value: 15,
		label: '15年'
	}, {
		value: 16,
		label: '16年'
	}, {
		value: 17,
		label: '17年'
	}, {
		value: 18,
		label: '18年'
	}, {
		value: 19,
		label: '19年'
	}, {
		value: 20,
		label: '20年'
	}, {
		value: 21,
		label: '21年'
	}, {
		value: 22,
		label: '22年'
	}, {
		value: 23,
		label: '23年'
	}, {
		value: 24,
		label: '24年'
	},
	{
		value: 25,
		label: '25年'
	},
	{
		value: 26,
		label: '26年'
	},
	{
		value: 27,
		label: '27年'
	},
	{
		value: 28,
		label: '28年'
	},
	{
		value: 29,
		label: '29年'
	},
	{
		value: 30,
		label: '30年'
	},
]

export default workExperienceOptions;



// WEBPACK FOOTER //
// ./src/components/EditResume/dataJson.js